import { configureStore } from '@reduxjs/toolkit'
import bookingSlice from './bookingSlice.tsx'
import tokenSlice from './tokenSlice.tsx'
import webSlice from './webSlice.tsx'

interface PreloadedState {}

export const createStore = (preloadedState?: PreloadedState) =>
  configureStore({
    reducer: {
      booking: bookingSlice,
      web: webSlice,
      token: tokenSlice,
    },
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({ serializableCheck: false })
    },
    devTools: import.meta.env.DEV,
  })

const tempStore = createStore()

// Ableiten der Typen `RootState` und `AppDispatch` vom temporären Store
export type RootState = ReturnType<typeof tempStore.getState>
export type AppDispatch = typeof tempStore.dispatch
